<template>
  <div class="row mt-3">
    <div class="col-md-6 col-lg-8">
      <h4>PRODUCTOS</h4>
      <div>
        <app-checkbox v-model="seeNames">Ver nombres</app-checkbox>
      </div>
      <div ref="elMinW" id="listProducts">
        <ListProducts
          ref="elListProducts"
          @productSelected="productSelectedHandler"
          @productRemoved="productSelectedHandler"
          :seeNames="seeNames"
        ></ListProducts>
      </div>
    </div>
    <div class="col-md-6 col-lg-4">
      <div class="row">
        <div class="col">
          <!-- <SideCashBox class="mb-1"></SideCashBox> -->
          <h4>SELECCION</h4>
          <SelectedProductsTable
            :disabled="false"
            ref="elSelPT"
            :list="list"
          ></SelectedProductsTable>
          <div v-show="list.length > 0">
            <app-button-submit @click="showPreview">
              Registrar
            </app-button-submit>
            <button class="btn btn-secondary ml-1" @click="reset">
              Reiniciar
            </button>
          </div>
        </div>
      </div>
    </div>

    <app-modal-basic ref="elModalForm">
      <InternalForm
        ref="elFormRequest"
        @submitted="submittedHandler"
      ></InternalForm>
    </app-modal-basic>
  </div>
</template>
<script>
import ListProducts from "./ListProducts.vue";
import InternalForm from "./InternalForm.vue";
import SelectedProductsTable from "./SelectProductsTable.vue";
import { mapState } from "vuex";
// import SideCashBox from "./SideCashBox.vue";

export default {
  components: {
    ListProducts,
    InternalForm,
    SelectedProductsTable
    // SideCashBox
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    list: [],
    cashBoxId: 0,
    seeNames: true
  }),

  computed: {
    ...mapState({})
  },

  watch: {
    //
  },

  mounted() {
    // this.$refs.elMinW.style.maxHeight = `${window.innerHeight - 100}px`;
  },

  methods: {
    submittedHandler() {
      this.list = [];
      this.$refs.elListProducts.reset();
    },
    reset() {
      this.list = [];
      this.$refs.elListProducts.reset();
    },
    showPreview() {
      this.$refs.elModalForm.show();
      this.$refs.elFormRequest.prepare(JSON.parse(JSON.stringify(this.list)));
    },
    productSelectedHandler() {
      this.list = this.$refs.elListProducts.getListSelected();
    }
  }
};
</script>

<style scoped>
#listProducts {
  height: 85vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
